export default __webpack_public_path__ + "static/media/1046.b25c8b6d.png";